import { render } from "./GamificationLeaderboardFriends.vue?vue&type=template&id=6238e519"
import script from "./GamificationLeaderboardFriends.vue?vue&type=script&lang=js"
export * from "./GamificationLeaderboardFriends.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__